<template>
    <div style="margin-top:70px;">
        <Filters />
        <TabNavigation />

        <div>
            <day-detail
                :title="'Planificación del día'"
                :anchor="'anchor'"
                :day="currentSelectedDate"
            ></day-detail>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Filters from "../../components/Filters/Filters.vue";
import TabNavigation from "../../components/Common/TabNavigation.vue";
import DayDetail from '../../components/Dashboard/DayDetail.vue';
import DaysMixins from '../../components/Mixins/DaysMixins'

import {mapGetters } from "vuex";

export default {
    components: {
        Filters,
        TabNavigation,
        DayDetail
    },
    computed: {
        ...mapGetters(["filterDate"]),
        currentSelectedDate() {
            this.$store.currentSelectedDate
            return this.$moment(this.filterDate)
        }
    },
    watch: {
        filterDate: {
            handler: function() {
                console.log('date changed')
                // trigger update plan day screen with the new selected day from the filter

            },
            deep:true
        }
    }
}
</script>